import logoWhatsapp from "../../assets/img/whatsapp-logo.png"
import logoSiebel from "../../assets/img/siebel-logo.png"
import logoGisData from "../../assets/img/gis_data-logo.png"
import logoSharepoint from "../../assets/img/sharepoint-logo.png"
import logoIzzi from "../../assets/img/izzi-vertical-claro-logo.svg"

import imagenVentas from "../../assets/img/point-of-sale.png"
import imagenPassword from "../../assets/img/password.png"
import imagenMapa from "../../assets/img/search.png"

import {Col, Container, Row} from "react-bootstrap";
import {ShortcutCard} from "../shortcuts/ShortcutCard";

export const Shortcuts = () => {
    const shortcuts = [
        {
            title: "Whatsapp Web",
            description: "Comunicación con los clientes",
            imgUrl: logoWhatsapp,
            url: "https://web.whatsapp.com",
            isExternal: true,
        },
        {
            title: "Siebel",
            description: "Consulta de clientes y domicilios",
            imgUrl: logoSiebel,
            url: "https://crm.izzi.mx/siebel/app/ecommunications/esn",
            isExternal: true,
        },
        {
            title: "Consulta de cobertura y clientes",
            description: "GIS Data",
            imgUrl: logoGisData,
            url: "https://gdv-p.sunvizion.izzi.mx/",
            isExternal: true,
        },
        {
            title: "Prospectos y contratos",
            description: "Portal OC",
            imgUrl: logoIzzi,
            url: "https://oc.izzidigital.mx/",
            isExternal: true,
        },
        {
            title: "Intranet de izzi",
            description: "Izzi telco",
            imgUrl: logoSharepoint,
            url: "https://izzitelco.sharepoint.com/",
            isExternal: true,
        },
        {
            title: "Revisar ventas por supervisor",
            description: "izzi PSA",
            imgUrl: imagenVentas,
            url: "https://psa.izzi.mx/",
            isExternal: true,
        },
        {
            title: "Cambio de contraseña",
            description: "Acceso Red Izzi",
            imgUrl: imagenPassword,
            url: "https://accesored.izzi.mx/",
            isExternal: true,
        }, {
            title: "¿Dónde está mi técnico?",
            description: "izzi PST",
            imgUrl: imagenMapa,
            url: "https://pst.izzi.mx/PST#/login/",
            isExternal: true,
        },
    ];

    return (
        <section className="shortcut" id="shortcuts">
            <Container>
                <h2>Accesos directos</h2>
                <p>Los enlaces más comunes para tu trabajo.</p>
                <Row>
                    {shortcuts.map((shortcut, index) => (
                        <Col key={index} xs={4} sm={3} md={3} lg={2}>
                            <ShortcutCard {...shortcut} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}
